// Read Only Managers can view the program, users and reports but can't change anything (ICOV3-1715).
// Components use useIsReadOnlyManager() for logic and <CanEdit> to hide write controls.
import { useMemo } from "react";
import { getAuthUser } from "@/containers/App/auth";

export const READ_ONLY_MANAGER_ROLE = "Read Only Manager";

// Manager pages that are nothing but an action (send, invite, import, assign) or program administration
// (settings, theme, content, managers, subprograms) — redirected to the dashboard.
export const READ_ONLY_MANAGER_BLOCKED_PATHS = [
  "/manager/manage",
  "/manager/mobile-app",
  "/manager/invite-participant",
  "/manager/award-new-participant",
  "/manager/csv-import",
  "/manager/budget/manage-setup",
];

export const isReadOnlyManager = (user) => user?.loginAs?.name === READ_ONLY_MANAGER_ROLE;

export const isBlockedForReadOnlyManager = (pathname) =>
  READ_ONLY_MANAGER_BLOCKED_PATHS.some((path) => pathname === path || pathname?.startsWith(`${path}/`));

export const getManagerLandingPath = (user) =>
  isReadOnlyManager(user) ? "/manager/home" : "/manager/manage-and-reward";

// The login role only changes on a full page load (login, Login As, invitation), so read it once from the stored user.
// This also avoids waiting on the Redux store, which is empty until App hydrates it.
export const useIsReadOnlyManager = () => useMemo(() => isReadOnlyManager(getAuthUser()), []);

export const CanEdit = ({ children }) => (useIsReadOnlyManager() ? null : <>{children}</>);
